var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 180,
    viewBox: "0 0 238 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3125 0.75C9.99414 0.75 0 10.7441 0 23.0625C0 30.0816 3.30039 36.6824 8.925 40.9125L110.075 116.775C115.374 120.726 122.626 120.726 127.925 116.775L229.075 40.9125C234.7 36.6824 238 30.0816 238 23.0625C238 10.7441 228.006 0.75 215.688 0.75H22.3125ZM0 52.8125V149.5C0 165.909 13.341 179.25 29.75 179.25H208.25C224.659 179.25 238 165.909 238 149.5V52.8125L136.85 128.675C126.252 136.624 111.748 136.624 101.15 128.675L0 52.8125Z",
    fill: "url(#paint0_linear_43_5623)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43_5623",
    x1: 8.49999,
    y1: 8.00001,
    x2: 313,
    y2: 223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7971E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSend);
export default __webpack_public_path__ + "static/media/messageSend.0d70ac4a9b7b97cf4c44345af47d5cfe.svg";
export { ForwardRef as ReactComponent };